module.exports = __webpack_public_path__ + "static/material-card-basic-c9416f563a6a772def78ced0265ee68e.png";